var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Panel',{attrs:{"data":_vm.request}}),_c('hr'),_c('h3',[_vm._v("Histórico de Multas")]),(_vm.request && _vm.request.id)?_c('TicketHistories',{attrs:{"request":_vm.request}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }